import { render, staticRenderFns } from "./ItemListAll.vue?vue&type=template&id=4a57853c&scoped=true"
import script from "./ItemListAll.vue?vue&type=script&lang=js"
export * from "./ItemListAll.vue?vue&type=script&lang=js"
import style0 from "./ItemListAll.vue?vue&type=style&index=0&id=4a57853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a57853c",
  null
  
)

export default component.exports